import PropTypes from 'prop-types';
import React from 'react';
import {Alert, Fade} from 'react-bootstrap';
import Style from './style.scss';
import Cx from 'classnames';

var timer;

class AlertComp extends React.Component {

    meltAlert() {
        clearTimeout(timer);
        let self = this;
        let displayTime = 3000;
        if (this.props.displayTime && this.props.displayTime > 0) {
            displayTime = this.props.displayTime;
        }
        timer = setTimeout(() => {
            self.props.actions.toggleAlert(false);
        }, displayTime);
    }

    closeAlert() {
        this.props.actions.toggleAlert(false);
    }

    render() {
        let closeBtnDisplay;
        if (this.props.closeButton){
            closeBtnDisplay = <div className={Style.closeBtnWrapper}><div className={Style.alertCloseBtn} onClick={() => this.closeAlert()}>X</div></div>;
        }

        let alertDisplay;
        if (this.props.alertActive) {
            alertDisplay =  <Fade in={true}  onEntered={ this.meltAlert() } >
                <Alert bsStyle={this.props.alertStyle} className={Cx(Style.alertWrapper,'alertWrapper')} >
                    <div className={Style.alertIconWrapper}>
                        <span className={Cx('iconIssue',Style.icon, this.props.alertIcon, Style[this.props.alertIcon])} ></span>
                    </div>
                    <div aria-label={this.props.alertText} tabIndex='0' className={Cx(Style.alertTitleWrapper)} id='alertTitleWrapper'>
                        <div className={Style.alertTitle}>{this.props.alertTitle}</div>
                        <div>{this.props.alertText}</div>
                    </div>
                    {closeBtnDisplay}
                    <div className="clearfix"></div>
                </Alert>
            </Fade>
        }

        return (
            <div className={Style.alertContainer}>
                {alertDisplay}
            </div>
        )

    }

}


AlertComp.propTypes = {
    alertIcon: PropTypes.string.isRequired,
    alertTitle: PropTypes.string,
    alertText: PropTypes.string,
    alertStyle: PropTypes.string.isRequired,
    displayTime: PropTypes.number.isRequired,
    alertActive: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    closeButton: PropTypes.bool
};


export default AlertComp;


// WEBPACK FOOTER //
// ./components/Alert/AlertComp.js